import SvgIcon from "@mui/material/SvgIcon";

export const GrowDashDFL2DIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 90 90">
        <path d="M24.0003 39.0006C32.2847 39.0006 39.0006 32.2847 39.0006 24.0003C39.0006 15.7159 32.2847 9 24.0003 9C15.7159 9 9 15.7159 9 24.0003C9 32.2847 15.7159 39.0006 24.0003 39.0006Z" fill="#5D614F"/>
        <path d="M22.6621 56.604L56.6011 22.665L60.8437 26.9076L26.9047 60.8466L22.6621 56.604ZM26.9038 69.33L69.3298 26.904L73.5733 31.1466L31.1473 73.5726L26.9038 69.33ZM32.9986 81.0003H80.9983V33.0006L32.9986 81.0003Z" fill="#5D614F"/>
    </SvgIcon>
);